/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  SET_BEARER(state, accessToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
  },
  getToken(state, payload) {
    localStorage.setItem('accessToken', payload)
    // const date = new Date();
    // date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
    // document.cookie = 'auth' + "=" + payload + ";expires=" + date
    //   + ";domain=.ira-lex.com;path=/";
  },
  getSt(state, payload) {
    localStorage.setItem('accessSt', payload)
  },
  getUserDetail(state, payload) {
    localStorage.setItem('user', JSON.stringify(payload))
  }
}

